import { render, staticRenderFns } from "./MallList.vue?vue&type=template&id=b95c1f76&scoped=true&"
import script from "./MallList.vue?vue&type=script&lang=ts&"
export * from "./MallList.vue?vue&type=script&lang=ts&"
import style0 from "./MallList.vue?vue&type=style&index=0&id=b95c1f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95c1f76",
  null
  
)

export default component.exports